import * as angular from "angular";

angular
  .module('bringoz.admin.billing-accounts')
  .constant('BillingOrders_PN', {
    database: 'billingOrder'
  });
